var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-dropdown",
    {
      staticClass: "ml",
      attrs: { items: _vm.actionList, flat: "", up: "", left: "" },
      on: {
        click: function ($event) {
          return $event()
        },
      },
    },
    [_vm._v(" Menu "), _c("w-fa", { attrs: { icon: "chevron-down" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }